module.exports = __webpack_public_path__ + "assets/img/img259.0769ff0c.png";